/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiNoteInfo } from './ApiNoteInfo';
import {
    ApiNoteInfoFromJSON,
    ApiNoteInfoFromJSONTyped,
    ApiNoteInfoToJSON,
    ApiNoteInfoToJSONTyped,
} from './ApiNoteInfo';
import type { ApiAssignmentUser } from './ApiAssignmentUser';
import {
    ApiAssignmentUserFromJSON,
    ApiAssignmentUserFromJSONTyped,
    ApiAssignmentUserToJSON,
    ApiAssignmentUserToJSONTyped,
} from './ApiAssignmentUser';

/**
 * 
 * @export
 * @interface ApiSnoozeConfiguration
 */
export interface ApiSnoozeConfiguration {
    /**
     * 
     * @type {number}
     * @memberof ApiSnoozeConfiguration
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiSnoozeConfiguration
     */
    personId?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiSnoozeConfiguration
     */
    scenarioHandle?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiSnoozeConfiguration
     */
    scenarioReason?: string;
    /**
     * 
     * @type {ApiAssignmentUser}
     * @memberof ApiSnoozeConfiguration
     */
    createdBy: ApiAssignmentUser;
    /**
     * 
     * @type {Date}
     * @memberof ApiSnoozeConfiguration
     */
    createdTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof ApiSnoozeConfiguration
     */
    endTime?: Date;
    /**
     * 
     * @type {number}
     * @memberof ApiSnoozeConfiguration
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiSnoozeConfiguration
     */
    totalAmount?: number;
    /**
     * 
     * @type {ApiNoteInfo}
     * @memberof ApiSnoozeConfiguration
     */
    note: ApiNoteInfo;
}

/**
 * Check if a given object implements the ApiSnoozeConfiguration interface.
 */
export function instanceOfApiSnoozeConfiguration(value: object): value is ApiSnoozeConfiguration {
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('createdTime' in value) || value['createdTime'] === undefined) return false;
    if (!('note' in value) || value['note'] === undefined) return false;
    return true;
}

export function ApiSnoozeConfigurationFromJSON(json: any): ApiSnoozeConfiguration {
    return ApiSnoozeConfigurationFromJSONTyped(json, false);
}

export function ApiSnoozeConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiSnoozeConfiguration {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'personId': json['personId'] == null ? undefined : json['personId'],
        'scenarioHandle': json['scenarioHandle'] == null ? undefined : json['scenarioHandle'],
        'scenarioReason': json['scenarioReason'] == null ? undefined : json['scenarioReason'],
        'createdBy': ApiAssignmentUserFromJSON(json['createdBy']),
        'createdTime': (new Date(json['createdTime'])),
        'endTime': json['endTime'] == null ? undefined : (new Date(json['endTime'])),
        'amount': json['amount'] == null ? undefined : json['amount'],
        'totalAmount': json['totalAmount'] == null ? undefined : json['totalAmount'],
        'note': ApiNoteInfoFromJSON(json['note']),
    };
}

export function ApiSnoozeConfigurationToJSON(json: any): ApiSnoozeConfiguration {
    return ApiSnoozeConfigurationToJSONTyped(json, false);
}

export function ApiSnoozeConfigurationToJSONTyped(value?: ApiSnoozeConfiguration | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'personId': value['personId'],
        'scenarioHandle': value['scenarioHandle'],
        'scenarioReason': value['scenarioReason'],
        'createdBy': ApiAssignmentUserToJSON(value['createdBy']),
        'createdTime': value['createdTime'].toISOString(),
        'endTime': value['endTime'] == null ? value['endTime'] : value['endTime'].toISOString(),
        'amount': value['amount'],
        'totalAmount': value['totalAmount'],
        'note': ApiNoteInfoToJSON(value['note']),
    };
}

